import types from '../../actions.types';
import { getElsaIntegrations } from '../../../api-calls/products/products'
// import { getProducts } from '../../../api-calls/products/products'

const { PENDING, SUCCESS, FAILED } = types.products;

export default () => {

  return dispatch => {
    dispatch({ type: PENDING });
    getElsaIntegrations().then(data => {
      dispatch({
        type: SUCCESS,
        data: data
      });
    }).catch(error => {
      dispatch({
        type: FAILED,
        error: error
      });
    });

  }
}

